export default __webpack_public_path__ + "static/media/footer.16d2ebb5.svg";